/**
 * Локальные данные календаря RU/KK для форматов НФТ-09. Держим свои таблицы, а не Intl:
 * набор локалей ICU отличается между браузерами (казахский есть не везде одинаково), а формат
 * даты должен быть одинаковым в Chrome, Firefox, Safari и Яндекс Браузере (НФТ-08).
 * Это данные локали, а не тексты интерфейса, поэтому они не в i18n-ресурсах.
 */
export type AppLocale = 'ru' | 'kk';

export const APP_LOCALES: readonly AppLocale[] = ['ru', 'kk'];

export function isAppLocale(value: unknown): value is AppLocale {
  return value === 'ru' || value === 'kk';
}

/** Названия месяцев в родительном падеже (RU: «30 сентября») и в форме для даты (KK: «30 қыркүйек»). */
export const MONTHS_IN_DATE: Record<AppLocale, readonly string[]> = {
  ru: ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'],
  kk: ['қаңтар', 'ақпан', 'наурыз', 'сәуір', 'мамыр', 'маусым', 'шілде', 'тамыз', 'қыркүйек', 'қазан', 'қараша', 'желтоқсан'],
};

/** Названия месяцев для заголовка календаря («Сентябрь 2026» / «Қыркүйек 2026»). */
export const MONTHS_STANDALONE: Record<AppLocale, readonly string[]> = {
  ru: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
  kk: ['Қаңтар', 'Ақпан', 'Наурыз', 'Сәуір', 'Мамыр', 'Маусым', 'Шілде', 'Тамыз', 'Қыркүйек', 'Қазан', 'Қараша', 'Желтоқсан'],
};

/** Дни недели, начиная с понедельника (ISO), полные — строчными, как в середине фразы. */
export const WEEKDAYS_LONG: Record<AppLocale, readonly string[]> = {
  ru: ['понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота', 'воскресенье'],
  kk: ['дүйсенбі', 'сейсенбі', 'сәрсенбі', 'бейсенбі', 'жұма', 'сенбі', 'жексенбі'],
};

/** Короткие дни недели для сетки календаря. */
export const WEEKDAYS_SHORT: Record<AppLocale, readonly string[]> = {
  ru: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
  kk: ['Дс', 'Сс', 'Ср', 'Бс', 'Жм', 'Сн', 'Жс'],
};
